import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useNavigate } from "react-router";
import InputKendoRct from "../../../../control-components/input/input";
import ErrorHelper from "../../../../helper/error-helper";
import NOTIFICATION_MESSAGE from "../../../../helper/notification-messages";
import { clinicService } from "../../../../services/clinicService";
import Loader from "../../../../control-components/loader/loader";
import PhoneInputMask from "../../../../control-components/phone-input-mask/phone-input-mask";
import { Switch } from "@progress/kendo-react-inputs";

function AddClinicContact({ onClose, regionId, masterClinicId, state }) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);
  let [fields, setFields] = useState({
    name: "",
    phone: "",
    email: "",
    isPrimary: false,
  });
  useEffect(() => {
    if (state) {
      getClinicContactById();
    }
  }, []);

  const getClinicContactById = async () => {
    setLoading(true);
    await clinicService
      .getClinicContactById(state, regionId)
      .then((result) => {
        if (result.resultData) {
          const data = result.resultData;
          setFields((prevFields) => ({
            ...prevFields,
            name: data.name,
            phone: data.phone,
            email: data.email,
            isPrimary: data.isPrimary,
          }));
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    var emailPattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!fields.name) {
      formIsValid = false;
      errors["name"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.phone) {
      formIsValid = false;
      errors["phone"] = ErrorHelper.FIELD_BLANK;
    }
    if (!emailPattern.test(fields.email)) {
      formIsValid = false;
      errors["email"] = ErrorHelper.INVALID_EMAIL;
    }
    setErrors(errors);
    return formIsValid;
  };
  const handleChange = (e) => {
    if (e.target.props.name === "isPrimary") {
      const name = e.target.props.name;
      const value = e.value;
      setFields({
        ...fields,
        [name]: value,
      });
    } else {
      const name = e.target.name;
      const value = e.target.value;
      setFields({
        ...fields,
        [name]: value,
      });
    }
  };
  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      if (state) {
        updateClinicContact();
      } else {
        addClinicContact();
      }
    }
  };
  const addClinicContact = async () => {
    setLoading(true);
    await clinicService
      .addClinicContact(fields, regionId, masterClinicId)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.CLINIC_CONTACT_ADDED);
        onClose({ updated: true });
      })
      .catch((error) => {
        
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const updateClinicContact = async () => {
    setLoading(true);
    await clinicService
      .updateClinicContact(fields, state, regionId, masterClinicId)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.CLINIC_CONTACT_UPDATED);
        onClose({ updated: true });
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleValueChange = (e) => {
    const name = e.target.name;
    const rawValue = e.target.rawValue;
    setFields({
      ...fields,
      [name]: rawValue,
    });
  };
  return (
    <Dialog
      onClose={onClose}
      title={state ? "Edit Clinic Contact" : "Add Clinic Contact"}
      className="small-dailog width_90"
      width={"60%"}
      height={"auto"}
    >
      <div className="edit-Service-popup dialog-editp y-3 header-blue">
        <div className="mx-3">
          <div className="row align-items-center">
            <div className="col-12 mb-3 mt-3">
              <InputKendoRct
                value={fields.name}
                onChange={handleChange}
                name="name"
                label="Name"
                error={fields.name === "" && errors.name}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"Name"}
              />
            </div>
            <div className="col-12 mb-3">
              <PhoneInputMask
                validityStyles={settingError}
                value={fields.phone}
                onChange={handleValueChange}
                name="phone"
                label="Phone"
                error={fields.phone === "" && errors.phone}
                required={true}
                placeholder="Phone"
              />
            </div>
            <div className="col-12 mb-3">
              <InputKendoRct
                className="form-control"
                value={fields.email}
                onChange={handleChange}
                name="email"
                label="Email"
                placeholder="Email"
                required={true}
                error={fields.email === "" && errors.email}
                validityStyles={settingError}
              />
            </div>
            <div className="col-12 mb-3">
              <Switch
                label=""
                onChange={handleChange}
                checked={fields.isPrimary}
                name="isPrimary"
                onLabel={"Yes"}
                offLabel={"No"}
              />
              <span className="ml-2 mt-2">Primary Contact</span> 
            </div>
          </div>
        </div>
        {loading == true && <Loader />}
      </div>

      <div className="border-bottom-line"></div>
      <div className="d-flex my-4">
        <button
          className="green-btn  btn-primary btn-space border-0 mx-3"
          onClick={handleSubmit}
        >
          {state ? "Update" : "Add"}
        </button>
        <button className="btn grey-secondary btn-space" onClick={onClose}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
}
export default AddClinicContact;
